/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  // Check if printer has been set or not
  if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0); // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var printMyText = function printMyText() {
    var data = window.kiosk;
    var printText = "";
    var print80Line = "";
    if (localStorage.getItem("paperSize") == 1) print80Line = "______________";

    if (window.origin == "claim") {
      if (window.lang == "tl") {
        printText += "{CENTER}{BR}{H}REKLAMA RESIBU{/H}{BR}{BR}";
        printText += "Hameno ID:{BR}" + window.win.orderID + "{BR}";
        printText += "Data :{BR}" + window.jackpottime + "{BR}";
        printText += print80Line + "_______________________________";
        window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{LEFT}Favor prienxe detalle kliente nian.{BR}{BR}", 'ISO-8859-1');
        if (window.uname != "") window.DatecsPrinter.printText("{BR}{BR}Naran     :" + window.uname + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Naran     :_____________________{BR}{BR}", 'ISO-8859-1');
        if (window.uic != "") window.DatecsPrinter.printText("{BR}{BR}IC        :" + window.uic + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}IC        :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}GDPoints ID/                    ", 'ISO-8859-1');
        if (window.win.smsnum != "") window.DatecsPrinter.printText("{BR}{BR}Telemovel :" + window.win.smsnum + "{BR}{BR}{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Telemovel :_____________________{BR}{BR}{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}Asina     :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{BR}", 'ISO-8859-1');
      } else {
        printText += "{CENTER}{BR}{H}CLAIM RECEIPT{/H}{BR}{BR}";
        printText += "Order ID:{BR}" + window.win.orderID + "{BR}";
        printText += "Date :{BR}" + window.jackpottime + "{BR}";
        printText += print80Line + "_______________________________";
        window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{LEFT}Please fill in customer detail{BR}{BR}", 'ISO-8859-1');
        if (window.uname != "") window.DatecsPrinter.printText("{BR}{BR}Name      :" + window.uname + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Name      :_____________________{BR}{BR}", 'ISO-8859-1');
        if (window.uic != "") window.DatecsPrinter.printText("{BR}{BR}IC        :" + window.uic + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}IC        :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}GDPoints ID/                    ", 'ISO-8859-1');
        if (window.win.smsnum != "") window.DatecsPrinter.printText("{BR}{BR}Mobile No :" + window.win.smsnum + "{BR}{BR}{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Mobile No :_____________________{BR}{BR}{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}Sign      :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{BR}", 'ISO-8859-1');
      }

      for (var i = 0; i < window.win.strikes.length; i++) {
        var strike = window.win.strikes[i];
        window.DatecsPrinter.printText("{BR}" + strike.drawDate + ", " + strike.betPosition + " " + strike.number + ", " + strike.prize, 'ISO-8859-1');
      }

      if (window.lang == "tl") {
        window.DatecsPrinter.printText("{BR}{BR}{BR}Total presiu manan.: " + window.win.gross, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total manan impostu. (10%): " + window.win.tax, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total pagamentu likidu.: " + window.win.total, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{H}{CENTER}TOTAL  : $" + window.win.total, 'ISO-8859-1');
      } else {
        window.DatecsPrinter.printText("{BR}{BR}{BR}Total Prize Won: " + window.win.gross, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total Winning Tax (10%): " + window.win.tax, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total Net Payout: " + window.win.total, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{H}{CENTER}TOTAL  : $" + window.win.total, 'ISO-8859-1');
      }
    } else if (window.origin == "claimjackpot") {
      if (window.lang == "tl") {
        printText += "{CENTER}{BR}{H}REKLAMA JACKPOT RESIBU{/H}{BR}{BR}";
        printText += "Hameno ID:{BR}" + window.win.orderID + "{BR}";
        printText += "Data :{BR}" + window.jackpottime + "{BR}";
        printText += print80Line + "_______________________________";
        window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{LEFT}Favór prienxe detalle kliente nian.{BR}{BR}", 'ISO-8859-1');
        if (window.uname != "") window.DatecsPrinter.printText("{BR}{BR}Naran     :" + window.uname + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Naran     :_____________________{BR}{BR}", 'ISO-8859-1');
        if (window.uic != "") window.DatecsPrinter.printText("{BR}{BR}IC        :" + window.uic + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}IC        :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}GDPoints ID/                    ", 'ISO-8859-1');
        if (window.win.smsnum != "") window.DatecsPrinter.printText("{BR}{BR}Telemovel :" + window.win.smsnum + "{BR}{BR}{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Telemovel :_____________________{BR}{BR}{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}Asina     :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{BR}", 'ISO-8859-1');
      } else {
        printText += "{CENTER}{BR}{H}CLAIM RECEIPT{/H}{BR}{BR}";
        printText += "Order ID:{BR}" + window.win.orderID + "{BR}";
        printText += "Date :{BR}" + window.jackpottime + "{BR}";
        printText += print80Line + "_______________________________";
        window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{LEFT}Please fill in customer detail{BR}{BR}", 'ISO-8859-1');
        if (window.uname != "") window.DatecsPrinter.printText("{BR}{BR}Name      :" + window.uname + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Name      :_____________________{BR}{BR}", 'ISO-8859-1');
        if (window.uic != "") window.DatecsPrinter.printText("{BR}{BR}IC        :" + window.uic + "{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}IC        :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}GDPoints ID/                    ", 'ISO-8859-1');
        if (window.win.smsnum != "") window.DatecsPrinter.printText("{BR}{BR}Mobile No :" + window.win.smsnum + "{BR}{BR}{BR}{BR}", 'ISO-8859-1');else window.DatecsPrinter.printText("{BR}{BR}Mobile No :_____________________{BR}{BR}{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}Sign      :_____________________{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{BR}", 'ISO-8859-1');
      }

      for (var i = 0; i < window.win.strikes.length; i++) {
        var strike = window.win.strikes[i];
        window.DatecsPrinter.printText("{BR}" + strike.drawDate + ", " + strike.betPosition + " " + strike.number + ", " + strike.prize, 'ISO-8859-1');
      }

      if (window.lang == "tl") {
        window.DatecsPrinter.printText("{BR}{BR}{BR}Total presiu manan.: " + window.win.gross, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total manan impostu. (10%): " + window.win.tax, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total pagamentu likidu.: " + window.win.total, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{H}{CENTER}TOTAL  : $" + window.win.total, 'ISO-8859-1');
      } else {
        window.DatecsPrinter.printText("{BR}{BR}{BR}Total Prize Won: " + window.win.gross, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total Winning Tax (10%): " + window.win.tax, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}Total Net Payout: " + window.win.total, 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{H}{CENTER}TOTAL  : $" + window.win.total, 'ISO-8859-1');
      }
    } else {
      if (window.lang == "tl") {
        printText += "Hameno ID:{BR}" + window.kiosk.orderId + "{BR}{BR}";
        printText += window.kiosk.dateTime + "{BR}";
        printText += print80Line + "_______________________________";
        window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("Favor, hatudu resibu ba ema ne'ebe sei halo pagamentu.", 'ISO-8859-1');
      } else {
        printText += "Order ID:{BR}" + window.kiosk.orderId + "{BR}{BR}";
        printText += window.kiosk.dateTime + "{BR}";
        printText += print80Line + "_______________________________";
        window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("Please show this receipt to the cashier to make payment", 'ISO-8859-1');
      }
    } //printMyBarcode(window.win.orderID); 
    //printMyBarcode(window.kiosk.orderId);  


    window.DatecsPrinter.printText("{BR}{BR}{CENTER}", 'ISO-8859-1');
    if (window.origin == "claim" || window.origin == "claimjackpot") printMyBarcode(window.win.orderID);else printMyBarcode(window.kiosk.orderId);
  };

  var printMyImage = function printMyImage() {
    var image = new Image();
    image.src = 'static/images/gd.jpg';

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 100;
      canvas.width = 100;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyQR();
      });
    };
  };

  var printMyQR2 = function printMyQR2() {
    var qrcodejs = new QRCode("qrcode", {
      text: window.orderEntry,
      width: 150,
      height: 150,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    });

    var imageData = qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg").replace(/^data:image\/(png|jpg|jpeg);base64,/, "");

    console.log(qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg"));
    window.DatecsPrinter.printImage(imageData, //base64
    150, 150, 1, function () {
      printMyText();
    });
  };

  var printMyQR = function printMyQR() {
    var image = new Image();
    image.src = "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=" + window.kiosk.orderId + "&choe=UTF-8";

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 300;
      canvas.width = 300;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyText();
      });
    };
  };

  var printMyBarcode = function printMyBarcode(text) {
    var canvas = document.createElement("canvas");
    canvas.height = 400;
    canvas.width = 300;
    JsBarcode(canvas, text, {
      format: "CODE128",
      width: 2
    });
    var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    window.DatecsPrinter.printImage(imageData, //base64
    canvas.width, canvas.height, 1, function () {
      window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      if (localStorage.getItem("printerName") == "Printer001") window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      window.DatecsPrinter.writeHex('1B69');
      if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/");
      if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
    });
  };

  var printPurchase = function printPurchase() {
    if (!window.DatecsPrinter) {
      alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
    } else {
      window.bluetooth = localStorage.getItem("printer");
      if (window.bluetooth == null || window.bluetooth == undefined) window.bluetooth = 0;
      window.DatecsPrinter.listBluetoothDevices(function (devices) {
        localStorage.setItem("printerName", devices[window.bluetooth].name);
        window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {
          if (window.origin == "claim" || window.origin == "claimjackpot") {
            printMyText();
          } else {
            printMyQR2();
          }
        }, function () {
          //$f7.views.main.router.back();
          //$f7.views.main.router.back("/kiosk_home/",{force:true});
          if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/");
          if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
          alert(JSON.stringify(error));
        });
      }, function (error) {
        //$f7.views.main.router.back();
        //$f7.views.main.router.back("/kiosk_home/",{force:true});
        if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/");
        if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
        alert(JSON.stringify(error));
      });
    }
  };

  $on('pageAfterIn', function () {
    $f7.toolbar.hide(".toolbar-app");
  });
  $on('pageAfterOut', function () {
    $f7.toolbar.show(".toolbar-app");
  });
  $on('pageInit', function () {
    if (window.isPrint != true) return;
    window.isPrint = false;

    if (window.origin == "claim" || window.origin == "claimjackpot") {
      $('.button-cancel').hide();
    } else {
      $('.button-cancel').show();
    }

    printPreview();
    setTimeout(function () {//printPurchase();
    }, 2000);
    setInterval(function () {
      printPurchase();
    }, 7200000);
  });

  var printCancel = function printCancel() {
    //$f7.views.main.router.back("/kiosk_home/",{force:true});
    if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/");
    if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
  };

  var printPreview = function printPreview() {
    var orderId = "";

    if (window.origin == "claim" || window.origin == "claimjackpot") {
      orderId = window.win.orderID;
      $(".title-receipt").hide();
      $(".title-claim").show();
    } else {
      orderId = window.kiosk.orderId;
      $(".title-receipt").show();
      $(".title-claim").hide();
    }

    $f7.request({
      method: 'get',
      url: window.waypoint + 'search.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderId: orderId
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        $f7.preloader.hide();
        console.log(data);
        var data = JSON.parse(data);
        window.data = data;
        var htmlText = '';

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          htmlText = "\n              <div class=\"block\">\n                \n                <table width=100%>\n                  <thead>\n                    <tr>\n                      <th style=\"color:#555555;font-size:25px;font-weight:bold; text-align:left\">" + data.dateTime + "</th>\n                      <th style=\"color:#555555;font-size:25px;font-weight:bold; text-align:right\">" + data.orderID + "</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                  <tr>\n                      <td colspan=2><hr/></td>\n                  </tr>  \n              ";

          for (var i = 0; i < data.receipt.length; i++) {
            htmlText += "<tr><td colspan=2 style='font-size:20px;'><div style='background-color:#D6DBDF'>" + data.receipt[i].draw + "</div><table width=100%>";

            for (var j = 0; j < data.receipt[i].details.length; j++) {
              var amountType = "";

              for (var k = 0; k < data.receipt[i].details[j].amount.length; k++) {
                var numberType = data.receipt[i].details[j].amount[k].type;
                var numberValue = data.receipt[i].details[j].amount[k].value;

                if (numberValue == "0.00") {
                  numberType = "-";
                  numberValue = "----";
                }

                amountType += "<td style='font-size:20px;text-align:right'>" + numberType + "-" + numberValue + "</td>";
              }

              htmlText += "  \n                    <tr>\n                      <td style='font-size:25px'>" + data.receipt[i].details[j].type + "<span style='font-size:30px'><b> " + data.receipt[i].details[j].number + "</b></span></td>\n                      <td style='font-size:20px'>" + data.receipt[i].details[j].position + "</td> \n                      " + amountType + "\n                    </tr>   \n                  ";
            }

            htmlText += "</table></td></tr>";
          }

          console.log(data.total);
          $('.total').html(parseFloat(data.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
          var gd6DJPNumber = "";

          for (var i = 0; i < data.gd6DJPNumber.length; i++) {
            gd6DJPNumber += "\n                  <tr><td colspan=2>" + data.gd6DJPNumber[i].date + "</td></tr>\n                ";

            for (var j = 0; j < data.gd6DJPNumber[i].number.length; j++) {
              gd6DJPNumber += "\n                  <tr><td colspan=2>" + data.gd6DJPNumber[i].number[j] + "</td></tr>\n                  ";
            }
          }

          var color1 = "";
          if (data.GDP == "--------") color1 = "style='color:red'";
          htmlText += "\n                  <tr><td colspan=2 " + color1 + ">GDP:" + data.GDP + "</td></tr> \n                  <tr><td colspan=2 " + color1 + ">" + data.gd4dJP + "</td></tr>\n                  <tr><td colspan=2 " + color1 + ">" + data.gd6dJP + "</td></tr>\n                  " + gd6DJPNumber + "\n \n                  </tbody>\n                </table>\n              </div>\n              ";
          $('.printtext').html(htmlText);
          $update();
        } else {
          $f7.dialog.alert('Order Not Found', function () {
            if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/");
            if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
          });
        }
      },
      error: function error(data) {
        $f7.dialog.alert('Something wrong, data cannot be retrieved...', function () {
          if (window.service == "kiosk") $f7.views.main.router.navigate("/kiosk_home/");
          if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/");
        });
        $f7.preloader.hide();
      }
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="kiosk_receipt">

  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="title title-receipt">
        <span class='en'>Receipt Confirmation</span>
        <span class='cn'>收据确认</span>
        <span class='tl'>Resibu konfirmasaun</span>
      </div>
      <div class="title title-claim">
        <span class='en'>Claim Receipt</span>
        <span class='cn'>索赔收据</span>
        <span class='tl'>Reklema Resibu</span>
      </div>
    </div>
  </div>

  <div class="fab fab-extended fab-right-bottom color-teal">
    <a href="#" @click=${printPurchase}>
      <i class="icon f7-icons">printer</i>
      <div class="fab-text" style="font-size: 18px;">Print</div>
    </a>
  </div>

  <div class="fab fab-extended fab-left-bottom button-cancel" style="color:var(--f7-theme-color)">
    <a href="#" @click=${printCancel}>
      <i class="icon f7-icons">multiply</i>
      <div class="fab-text" style="font-size: 18px;">
        <span class='en'>Cancel</span>
        <span class='cn'>取消</span>
        <span class='tl'>Kansela</span>
      </div>
    </a>
  </div>
  
  <div class="page-content" style="background-color: white; color:black;">
    <!-- <div class="block-title block-title-large">Receipt</div> -->
    <div class="printtext">

    </div>



    
    <div class="block" style="display: none;">
      <div style="text-align: center;">
        <div id="qrcode" style="display:none;"></div>
        <img id="barcode"/>

        <img src='static/images/printer.png' width="400px"/>
        <br/>
        
        <p>
          
            <span class='en'>Printing your receipt...</span>
            <span class='cn'>打印收据...</span>
            <span class='tl'>Imprime ita-boot Nia resibu.</span>
          
        </p>
      </div>
      
      <p style="text-align: center;">
        <!-- <button class="button-fill" @click=${printPurchase} style="font-size:30px;width: 500px; height: 300;">PRINT RECEIPT</button> -->
      </p>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '2b71830003';
export default framework7Component;